import React from 'react';
import { cn } from '../../lib/utils';
import { motion } from 'framer-motion';

export const GlassCard = React.forwardRef(({ 
  className, 
  children, 
  hover = true,
  glow = false,
  ...props 
}, ref) => {
  return (
    <motion.div
      ref={ref}
      className={cn(
        'bg-white/[0.03] backdrop-blur-xl border border-white/10 rounded-3xl overflow-hidden',
        hover && 'hover:bg-white/[0.07] hover:border-primary/50 transition-all duration-500',
        glow && 'relative',
        className
      )}
      whileHover={hover ? { scale: 1.01 } : undefined}
      {...props}
    >
      {glow && (
        <div className="absolute inset-0 -z-10">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-primary/20 to-secondary/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        </div>
      )}
      {children}
    </motion.div>
  );
});

GlassCard.displayName = 'GlassCard';
